// //30-12-2025

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { X, Save } from "lucide-react";
// import "../../css/commonFormModal.css";

// export default function LeadForm({ lead, onSave, onCancel, isLoading }) {
//   const [formData, setFormData] = useState({
//     full_name: lead?.full_name || "",
//     email: lead?.email || "",
//     phone: lead?.phone || "",
//     lead_type: lead?.lead_type || "buyer",
//     source: lead?.source || "website",
//     status: lead?.status || "new",
//     budget_min: lead?.budget_min || "",
//     budget_max: lead?.budget_max || "",
//     preferred_locations: Array.isArray(lead?.preferred_locations)
//       ? lead.preferred_locations
//       : [],
//     property_type: lead?.property_type || "Apartment",
//     interest_level: lead?.interest_level || "warm",
//     notes: lead?.notes || "",
//     source_other_reason: lead?.source_other_reason || "",
//     // property_other_reason: lead?.property_other_reason || "",
//   });

//   const [locationInput, setLocationInput] = useState("");

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     onSave(formData);
//   };

//   const addLocation = () => {
//     if (!locationInput.trim()) return;
//     setFormData((prev) => ({
//       ...prev,
//       preferred_locations: [...prev.preferred_locations, locationInput.trim()],
//     }));
//     setLocationInput("");
//   };

//   const removeLocation = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       preferred_locations: prev.preferred_locations.filter(
//         (_, i) => i !== index,
//       ),
//     }));
//   };

//   const formatINR = (value) => {
//     if (!value) return "";
//     const numeric = value.replace(/[^0-9]/g, "");
//     return new Intl.NumberFormat("en-IN").format(numeric);
//   };

//   return (
//     <motion.div
//       className="form-overlay"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//     >
//       <motion.div
//         className="form-card"
//         initial={{ scale: 0.95, y: 20 }}
//         animate={{ scale: 1, y: 0 }}
//         exit={{ scale: 0.95, y: 20 }}
//       >
//         {/* HEADER */}
//         <div className="form-header">
//           <h2>{lead ? "Edit Lead" : "Add New Lead"}</h2>
//           <button className="icon-btn" onClick={onCancel}>
//             <X size={18} />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit}>
//           {/* BODY */}
//           <div>
//             {/* Name & Phone */}
//             <div className="grid-2">
//               <div className="form-group">
//                 <label>Full Name *</label>
//                 <input
//                   name="full_name"
//                   value={formData.full_name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Phone *</label>
//                 <input
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>

//             {/* Email & Lead Type */}
//             <div className="grid-2">
//               <div className="form-group">
//                 <label>Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Lead Type</label>
//                 <select
//                   name="lead_type"
//                   value={formData.lead_type}
//                   onChange={handleChange}
//                 >
//                   <option value="buyer">Buyer</option>
//                   <option value="seller">Seller</option>
//                   <option value="renter">Tenant</option>
//                 </select>
//               </div>
//             </div>

//             {/* Source & Status */}
//             <div className="grid-2">
              
//               {/* 04-02-2026 */}

//               <div className="form-group">
//                 <label>Source</label>
//                 <select
//                   name="source"
//                   value={formData.source}
//                   onChange={handleChange}
//                 >
//                   <option value="website">Website</option>
//                   <option value="facebook">Social Media</option>
//                   <option value="google">Google</option>
//                   <option value="walkin">Walk-in</option>
//                   <option value="referral">Referral</option>
//                   <option value="whatsapp">Whatsapp</option>
//                   <option value="other">Other</option>
//                 </select>
//               </div>

//               {formData.source === "other" && (
//                 <div className="form-group">
//                   <label>Specify Source</label>
//                   <input
//                     name="source_other_reason"
//                     value={formData.source_other_reason}
//                     onChange={handleChange}
//                     placeholder="Enter source details"
//                     required
//                   />
//                 </div>
//               )}
//               <div className="form-group">
//                 <label>Budget Min (₹)</label>
//                 <input
//                   name="budget_min"
//                   value={formData.budget_min}
//                   onChange={(e) =>
//                     setFormData((prev) => ({
//                       ...prev,
//                       budget_min: formatINR(e.target.value),
//                     }))
//                   }
//                   placeholder="₹ 10,00,000"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Budget Max (₹)</label>
//                 <input
//                   name="budget_max"
//                   value={formData.budget_max}
//                   onChange={(e) =>
//                     setFormData((prev) => ({
//                       ...prev,
//                       budget_max: formatINR(e.target.value),
//                     }))
//                   }
//                   placeholder="₹ 50,00,000"
//                 />
//               </div>

              

//               {/* 04-02-2026 */}
//               <div className="form-group">
//                 <label>Property Type</label>

//                 <input
//                   list="propertyTypes"
//                   name="property_type"
//                   value={formData.property_type}
//                   onChange={handleChange}
//                   placeholder="Search or select property type"
//                 />

//                 <datalist id="propertyTypes">
//                   <option value="Apartment/Flat" />
//                   <option value="Villa" />
//                   <option value="Residential Plot/Land" />
//                   <option value="Independen House" />
//                   <option value="Studio Apartment" />
//                   <option value="Penthouse" />
//                   <option value="Builder Floor" />
//                   <option value="Office Space" />
//                   <option value="Commercial Shop" />
//                   <option value="Showroom" />
//                   <option value="SCO(Shop-Cum-Office)" />
//                   <option value="DSS(Double Storey Shop)" />
//                   <option value="Commercial Plot" />
                  
//                   {/* <option value="other" /> */}
//                 </datalist>
//               </div>

//               <div className="form-group">
//                 <label>Interest Level</label>
//                 <select
//                   name="interest_level"
//                   value={formData.interest_level}
//                   onChange={handleChange}
//                 >
//                   <option value="cold">Cold</option>
//                   <option value="warm">Warm</option>
//                   <option value="hot">Hot</option>
//                 </select>
//               </div>
//             </div>

//             {/* Preferred Locations */}
//             <div className="form-group">
//               <label>Preferred Locations</label>

//               <div className="tag-input">
//                 <input
//                   value={locationInput}
//                   onChange={(e) => setLocationInput(e.target.value)}
//                   placeholder="Add location"
//                 />
//                 <button type="button" onClick={addLocation}>
//                   Add
//                 </button>
//               </div>

//               <div className="tags">
//                 {formData.preferred_locations.map((loc, i) => (
//                   <span key={i} className="tag">
//                     {loc}
//                     <button type="button" onClick={() => removeLocation(i)}>
//                       <X size={12} />
//                     </button>
//                   </span>
//                 ))}
//               </div>
//             </div>

//             {/* Notes */}
//             <div className="form-group">
//               <label>Notes</label>
//               <textarea
//                 name="notes"
//                 rows="3"
//                 value={formData.notes}
//                 onChange={handleChange}
//               />
//             </div>

//             {/* FOOTER */}
//             <div className="form-footer">
//               <button type="button" className="btn-outline" onClick={onCancel}>
//                 Cancel
//               </button>

//               <button
//                 type="submit"
//                 className="btn-primary"
//                 disabled={isLoading}
//               >
//                 <Save size={16} />
//                 {isLoading ? "Saving..." : "Save Lead"}
//               </button>
//             </div>
//           </div>
//         </form>
//       </motion.div>
//     </motion.div>
//   );
// }

// Updated: 06-04-2026
// Changes:
// - Budget Min/Max inputs now accept decimal values (step="any" added)
// - Budget fields now have number input + unit dropdown (Thousands/Lakhs/Crores)
// - Property Type is a searchable dropdown with ability to add custom types
// - All dropdowns have a default "Select" option
// - Source, Status, Lead Type, Interest Level are now searchable via combobox pattern

import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { X, Save, Search, Plus, ChevronDown, Building2 } from "lucide-react";
import api from "../../api/api";
import "../../css/commonFormModal.css";

/* ─────────────────────────────────────────────
   SearchableSelect – generic combobox component
───────────────────────────────────────────── */
function SearchableSelect({ name, value, onChange, options, placeholder = "Select..." }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = options.filter((o) =>
    o.label.toLowerCase().includes(query.toLowerCase())
  );

  const selectedLabel = options.find((o) => o.value === value)?.label || "";

  const handleSelect = (val) => {
    onChange({ target: { name, value: val } });
    setOpen(false);
    setQuery("");
  };

  return (
    <div className="searchable-select" ref={ref}>
      <div
        className={`ss-trigger ${open ? "open" : ""}`}
        onClick={() => setOpen((p) => !p)}
      >
        <span className={selectedLabel ? "ss-value" : "ss-placeholder"}>
          {selectedLabel || placeholder}
        </span>
        <ChevronDown size={14} className={`ss-chevron ${open ? "rotated" : ""}`} />
      </div>

      {open && (
        <div className="ss-dropdown">
          <div className="ss-search">
            <Search size={13} />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search..."
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <ul className="ss-list">
            {filtered.length === 0 && (
              <li className="ss-empty">No results</li>
            )}
            {filtered.map((o) => (
              <li
                key={o.value}
                className={`ss-item ${o.value === value ? "selected" : ""}`}
                onClick={() => handleSelect(o.value)}
              >
                {o.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   PropertyTypeSelect – searchable + add custom
───────────────────────────────────────────── */
const DEFAULT_PROPERTY_TYPES = [
  "Apartment/Flat",
  "Villa",
  "Residential Plot/Land",
  "Independent House",
  "Studio Apartment",
  "Penthouse",
  "Builder Floor",
  "Office Space",
  "Commercial Shop",
  "Showroom",
  "SCO (Shop-Cum-Office)",
  "DSS (Double Storey Shop)",
  "Commercial Plot",
];

function PropertyTypeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [types, setTypes] = useState(DEFAULT_PROPERTY_TYPES);
  const [addMode, setAddMode] = useState(false);
  const [newType, setNewType] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setAddMode(false); } };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = types.filter((t) =>
    t.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (val) => {
    onChange({ target: { name: "property_type", value: val } });
    setOpen(false);
    setQuery("");
    setAddMode(false);
  };

  const handleAdd = () => {
    const trimmed = newType.trim();
    if (!trimmed || types.includes(trimmed)) return;
    setTypes((prev) => [...prev, trimmed]);
    handleSelect(trimmed);
    setNewType("");
  };

  return (
    <div className="searchable-select" ref={ref}>
      <div
        className={`ss-trigger ${open ? "open" : ""}`}
        onClick={() => setOpen((p) => !p)}
      >
        <span className={value ? "ss-value" : "ss-placeholder"}>
          {value || "Select property type..."}
        </span>
        <ChevronDown size={14} className={`ss-chevron ${open ? "rotated" : ""}`} />
      </div>

      {open && (
        <div className="ss-dropdown">
          <div className="ss-search">
            <Search size={13} />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search property type..."
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          <ul className="ss-list">
            {filtered.length === 0 && !addMode && (
              <li className="ss-empty">No results found</li>
            )}
            {filtered.map((t) => (
              <li
                key={t}
                className={`ss-item ${t === value ? "selected" : ""}`}
                onClick={() => handleSelect(t)}
              >
                {t}
              </li>
            ))}
          </ul>

          {/* Add custom type */}
          <div className="ss-add-section">
            {!addMode ? (
              <button
                type="button"
                className="ss-add-btn"
                onClick={(e) => { e.stopPropagation(); setAddMode(true); }}
              >
                <Plus size={13} /> Add custom type
              </button>
            ) : (
              <div className="ss-add-input">
                <input
                  autoFocus
                  value={newType}
                  onChange={(e) => setNewType(e.target.value)}
                  placeholder="e.g. Warehouse"
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleAdd(); } }}
                  onClick={(e) => e.stopPropagation()}
                />
                <button type="button" className="ss-add-confirm" onClick={handleAdd}>
                  Add
                </button>
                <button type="button" className="ss-add-cancel" onClick={() => { setAddMode(false); setNewType(""); }}>
                  <X size={13} />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   BudgetInput – number + unit (Thousands/Lakhs/Crores)
───────────────────────────────────────────── */
const BUDGET_UNITS = [
  { value: "thousands", label: "Thousands", multiplier: 1_000 },
  { value: "lakhs", label: "Lakhs", multiplier: 100_000 },
  { value: "crores", label: "Crores", multiplier: 10_000_000 },
];

function BudgetInput({ label, fieldName, value, unit, onValueChange, onUnitChange }) {
  return (
    <div className="form-group">
      <label>{label} (₹)</label>
      <div className="budget-input-group">
        <input
          type="number"
          name={fieldName}
          value={value}
          onChange={onValueChange}
          placeholder="0"
          min="0"
          step="any"
          className="budget-number"
        />
        <select
          value={unit}
          onChange={onUnitChange}
          className="budget-unit"
        >
          {BUDGET_UNITS.map((u) => (
            <option key={u.value} value={u.value}>{u.label}</option>
          ))}
        </select>
      </div>
      {value && (
        <span className="budget-preview">
          ₹ {new Intl.NumberFormat("en-IN").format(
            value * (BUDGET_UNITS.find((u) => u.value === unit)?.multiplier || 1)
          )}
        </span>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────────
   Option lists for searchable selects
───────────────────────────────────────────── */
const LEAD_TYPE_OPTIONS = [
  { value: "", label: "Select lead type..." },
  { value: "buyer", label: "Buyer" },
  // { value: "seller", label: "Seller" },
  { value: "renter", label: "Tenant" },
];

const SOURCE_OPTIONS = [
  { value: "", label: "Select source..." },
  { value: "website", label: "Website" },
  { value: "facebook", label: "Social Media" },
  { value: "google", label: "Google" },
  { value: "walkin", label: "Walk-in" },
  { value: "referral", label: "Referral" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "other", label: "Other" },
];

const STATUS_OPTIONS = [
  { value: "", label: "Select status..." },
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "interested", label: "Interested" },
  { value: "follow_up", label: "Follow-up" },
  { value: "matured", label: "Matured", isMatured: true },
  { value: "closed", label: "Closed" },
  { value: "lost", label: "Lost" },
];

const INTEREST_OPTIONS = [
  { value: "", label: "Select interest level..." },
  { value: "cold", label: "Cold" },
  { value: "warm", label: "Warm" },
  { value: "hot", label: "Hot" },
];

/* ─────────────────────────────────────────────
   Main LeadForm component
───────────────────────────────────────────── */
export default function LeadForm({ lead, onSave, onCancel, isLoading }) {
  const [formData, setFormData] = useState({
    full_name: lead?.full_name || "",
    email: lead?.email || "",
    phone: lead?.phone || "",
    lead_type: lead?.lead_type || "",
    source: lead?.source || "",
    status: lead?.status || "new",
    // Budget stored as raw number string + unit separately
    budget_min_value: "",
    budget_min_unit: "lakhs",
    budget_max_value: "",
    budget_max_unit: "lakhs",
    preferred_locations: Array.isArray(lead?.preferred_locations)
      ? lead.preferred_locations
      : [],
    property_type: lead?.property_type || "",
    interest_level: lead?.interest_level || "",
    notes: lead?.notes || "",
    source_other_reason: lead?.source_other_reason || "",
    propertyId: lead?.propertyId || "",
  });

  const [locationInput, setLocationInput] = useState("");
  const [properties,    setProperties]    = useState([]);

  // ── Fetch available properties for linking ──
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/properties");
        if (!cancelled) {
          const data = Array.isArray(res.data) ? res.data : (res.data?.properties || []);
          setProperties(data);
        }
      } catch (_) { /* silent — property linking is optional */ }
    })();
    return () => { cancelled = true; };
  }, []);

  // Parse existing budget values if editing a lead
  useEffect(() => {
    if (lead) {
      if (lead.budget_min) {
        const parsed = parseBudgetString(lead.budget_min);
        setFormData((prev) => ({ ...prev, budget_min_value: parsed.value, budget_min_unit: parsed.unit }));
      }
      if (lead.budget_max) {
        const parsed = parseBudgetString(lead.budget_max);
        setFormData((prev) => ({ ...prev, budget_max_value: parsed.value, budget_max_unit: parsed.unit }));
      }
    }
  }, []);

  // Try to parse a stored budget value back to value+unit
  // Handles both Number (from DB) and String types
  function parseBudgetString(str) {
    const numeric = typeof str === "number" ? str : parseFloat(String(str).replace(/[^0-9.]/g, ""));
    if (isNaN(numeric)) return { value: "", unit: "lakhs" };
    if (numeric >= 10_000_000) return { value: String(numeric / 10_000_000), unit: "crores" };
    if (numeric >= 100_000) return { value: String(numeric / 100_000), unit: "lakhs" };
    return { value: String(numeric / 1_000), unit: "thousands" };
  }

  // Convert budget value+unit to raw number string for backend
  function computeBudget(value, unit) {
    if (!value) return "";
    const multiplier = BUDGET_UNITS.find((u) => u.value === unit)?.multiplier || 1;
    return String(parseFloat(value) * multiplier);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      budget_min: computeBudget(formData.budget_min_value, formData.budget_min_unit),
      budget_max: computeBudget(formData.budget_max_value, formData.budget_max_unit),
    };
    // Remove UI-only fields before sending
    delete payload.budget_min_value;
    delete payload.budget_min_unit;
    delete payload.budget_max_value;
    delete payload.budget_max_unit;
    onSave(payload);
  };

  const addLocation = () => {
    if (!locationInput.trim()) return;
    setFormData((prev) => ({
      ...prev,
      preferred_locations: [...prev.preferred_locations, locationInput.trim()],
    }));
    setLocationInput("");
  };

  const removeLocation = (index) => {
    setFormData((prev) => ({
      ...prev,
      preferred_locations: prev.preferred_locations.filter((_, i) => i !== index),
    }));
  };

  return (
    <motion.div
      className="form-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="form-card"
        initial={{ scale: 0.95, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.95, y: 20 }}
      >
        {/* HEADER */}
        <div className="form-header">
          <h2>{lead ? "Edit Lead" : "Add New Lead"}</h2>
          <button className="icon-btn" onClick={onCancel}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div>
            {/* Name & Phone */}
            <div className="grid-2">
              <div className="form-group">
                <label>Full Name *</label>
                <input
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Phone *</label>
                <input
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Email & Lead Type */}
            <div className="grid-2">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Lead Type</label>
                <SearchableSelect
                  name="lead_type"
                  value={formData.lead_type}
                  onChange={handleChange}
                  options={LEAD_TYPE_OPTIONS}
                  placeholder="Select lead type..."
                />
              </div>
            </div>

            {/* Source & Status */}
            <div className="grid-2">
              <div className="form-group">
                <label>Source</label>
                <SearchableSelect
                  name="source"
                  value={formData.source}
                  onChange={handleChange}
                  options={SOURCE_OPTIONS}
                  placeholder="Select source..."
                />
              </div>
              <div className="form-group">
                <label>Status</label>
                <SearchableSelect
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  options={STATUS_OPTIONS}
                  placeholder="Select status..."
                />
              </div>
            </div>

            {/* Specify source if "other" */}
            {formData.source === "other" && (
              <div className="form-group">
                <label>Specify Source *</label>
                <input
                  name="source_other_reason"
                  value={formData.source_other_reason}
                  onChange={handleChange}
                  placeholder="Enter source details"
                  required
                />
              </div>
            )}

            {/* Budget Min & Max */}
            <div className="grid-2">
              <BudgetInput
                label="Budget Min"
                fieldName="budget_min_value"
                value={formData.budget_min_value}
                unit={formData.budget_min_unit}
                onValueChange={handleChange}
                onUnitChange={(e) => setFormData((prev) => ({ ...prev, budget_min_unit: e.target.value }))}
              />
              <BudgetInput
                label="Budget Max"
                fieldName="budget_max_value"
                value={formData.budget_max_value}
                unit={formData.budget_max_unit}
                onValueChange={handleChange}
                onUnitChange={(e) => setFormData((prev) => ({ ...prev, budget_max_unit: e.target.value }))}
              />
            </div>

            {/* Property Type & Interest Level */}
            <div className="grid-2">
              <div className="form-group">
                <label>Property Type</label>
                <PropertyTypeSelect
                  value={formData.property_type}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Interest Level</label>
                <SearchableSelect
                  name="interest_level"
                  value={formData.interest_level}
                  onChange={handleChange}
                  options={INTEREST_OPTIONS}
                  placeholder="Select interest level..."
                />
              </div>
            </div>

            {/* Linked Property (optional) */}
            <div className="form-group">
              <label>
                <Building2 size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "-2px" }} />
                Linked Property (optional)
              </label>
              <SearchableSelect
                name="propertyId"
                value={formData.propertyId}
                onChange={handleChange}
                options={[
                  { value: "", label: "— No property linked —" },
                  ...properties
                    .filter(p => !lead || p.status === "available" || p._id === formData.propertyId)
                    .map(p => ({
                      value: p._id,
                      label: `${p.propertyName}${p.location ? " — " + p.location : ""}${p.price ? " (₹" + Number(p.price).toLocaleString("en-IN") + ")" : ""}`,
                    })),
                ]}
                placeholder="Select property this lead is interested in..."
              />
            </div>

            {/* Preferred Locations */}
            <div className="form-group">
              <label>Preferred Locations</label>
              <div className="tag-input">
                <input
                  value={locationInput}
                  onChange={(e) => setLocationInput(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addLocation(); } }}
                  placeholder="Add location"
                />
                <button type="button" onClick={addLocation}>Add</button>
              </div>
              <div className="tags">
                {formData.preferred_locations.map((loc, i) => (
                  <span key={i} className="tag">
                    {loc}
                    <button type="button" onClick={() => removeLocation(i)}>
                      <X size={12} />
                    </button>
                  </span>
                ))}
              </div>
            </div>

            {/* Notes */}
            <div className="form-group">
              <label>Notes</label>
              <textarea
                name="notes"
                rows="3"
                value={formData.notes}
                onChange={handleChange}
              />
            </div>

            {/* FOOTER */}
            <div className="form-footer">
              <button type="button" className="btn-outline" onClick={onCancel}>
                Cancel
              </button>
              <button type="submit" className="btn-primary" disabled={isLoading}>
                <Save size={16} />
                {isLoading ? "Saving..." : "Save Lead"}
              </button>
            </div>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
}